import { Object3D, Raycaster, Vector3 } from 'three';

import { NavMeshQuery } from '@recast-navigation/core';

/**
 * find distance of a random point in navmesh to a given object.
 * By default, distance is calculated towards -ve Y-axis(towards floor)
 */
export const navMeshDistanceFromObject = (
  navMeshQuery: NavMeshQuery,
  obj: Object3D,
  direction?: Vector3
): number => {
  const result = navMeshQuery.findRandomPoint();
  if (result.success) {
    const interesections = new Raycaster(
      new Vector3(result.randomPoint.x, result.randomPoint.y, result.randomPoint.z),
      direction ? direction : new Vector3(0, -1, 0) // towards floor by default
    ).intersectObject(obj);
    if (interesections.length > 0) {
      return interesections[0].point.y - result.randomPoint.y;
    } else {
      console.warn('Could not find object distance from navmesh');
    }
  } else {
    console.warn('Could not locate a point on navmesh');
  }

  return 0;
};
